import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { Sizing } from '@faire/web-api--source/indigofair/data/Sizing';

export namespace IFaireIcon {
  /**
   * Originally generated from the Slate 1 icon set: https://slate.faire.team/icons/slate
   * It comprises a subset of Slate 2 foundational icons, along with external/social icons, and non‑Slate contextual/experimental icons.
   */
  export enum Type {
    TYPE_UNKNOWN = 'TYPE_UNKNOWN',
    /**
     * Slate Icons
     * TODO: Update to align with Slate 2 (Responsible Consumption)
     */
    RESPONSIBLE_CONSUMPTION_AND_PRODUCTION = 'RESPONSIBLE_CONSUMPTION_AND_PRODUCTION',
    SPROUT = 'SPROUT',
    SHARE_HEART = 'SHARE_HEART',
    CHECK_OUTLINE = 'CHECK_OUTLINE',
    /**
     * TODO: Update to align with Slate 2 (Arrow Right)
     */
    ARROW = 'ARROW',
    ACCOUNT = 'ACCOUNT',
    ADD = 'ADD',
    ANNOUNCEMENT = 'ANNOUNCEMENT',
    ANNOUNCEMENT_MUTED = 'ANNOUNCEMENT_MUTED',
    APPLICATION = 'APPLICATION',
    BAR_GRAPH = 'BAR_GRAPH',
    BLOCK = 'BLOCK',
    /**
     * TODO: Update to align with Slate 2 (Sale Tag)
     */
    BOOKMARK_TAG = 'BOOKMARK_TAG',
    CALENDAR = 'CALENDAR',
    CART_EMPTY = 'CART_EMPTY',
    CART_ITEMS = 'CART_ITEMS',
    CAUTION = 'CAUTION',
    CHAT_BUBBLE = 'CHAT_BUBBLE',
    CHEVRON = 'CHEVRON',
    CLOCK = 'CLOCK',
    CLOSE = 'CLOSE',
    CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
    DIAMOND = 'DIAMOND',
    EARN = 'EARN',
    EDIT = 'EDIT',
    EMAIL = 'EMAIL',
    ESTIMATED_DELIVERY_DATE = 'ESTIMATED_DELIVERY_DATE',
    EXCLAMATION = 'EXCLAMATION',
    EXCLAMATION_SOLID = 'EXCLAMATION_SOLID',
    EXCLUSIVITY = 'EXCLUSIVITY',
    EXPAND = 'EXPAND',
    /**
     * TODO: Update to align with Slate 2 (Eye Open)
     */
    EYE = 'EYE',
    EYE_CLOSED = 'EYE_CLOSED',
    FILTER = 'FILTER',
    GLOBE = 'GLOBE',
    GRAPH = 'GRAPH',
    GROUP = 'GROUP',
    HEART = 'HEART',
    INFORMATION = 'INFORMATION',
    LINK = 'LINK',
    LIGHTBULB = 'LIGHTBULB',
    LOCK = 'LOCK',
    MINIMIZE = 'MINIMIZE',
    PARTY_POPPER = 'PARTY_POPPER',
    PAYMENT_PLAN = 'PAYMENT_PLAN',
    PIN = 'PIN',
    RELATIONSHIPS = 'RELATIONSHIPS',
    RETURNS = 'RETURNS',
    SAVE = 'SAVE',
    SEARCH = 'SEARCH',
    SEND = 'SEND',
    SHARE = 'SHARE',
    SHIPMENT_DELIVERED = 'SHIPMENT_DELIVERED',
    SHIPPING = 'SHIPPING',
    SHIPS_FROM = 'SHIPS_FROM',
    SHOPPING_BAG = 'SHOPPING_BAG',
    SORT = 'SORT',
    /**
     * TODO: Update to align with Slate 2 (Star Outlined)
     */
    STAR = 'STAR',
    STAR_FILLED = 'STAR_FILLED',
    SYNCHRONIZED = 'SYNCHRONIZED',
    SYNCHRONIZED_WARNING = 'SYNCHRONIZED_WARNING',
    TRASH_CAN = 'TRASH_CAN',
    TRUCK = 'TRUCK',
    TWINKLE = 'TWINKLE',
    UNDO = 'UNDO',
    VERTICAL_ELLIPSIS = 'VERTICAL_ELLIPSIS',
    ALARM_CLOCK = 'ALARM_CLOCK',
    /**
     * Deprecated in favor of CHECK_OUTLINE. Background will be defined in parent element or component.
     * @deprecated
     */
    CHECK_IN_CIRCLE = 'CHECK_IN_CIRCLE',
    CIRCLE_FILLED = 'CIRCLE_FILLED',
    /**
     * TODO: Update to align with Slate 2 (Market)
     */
    FAIRE_SUMMER_MARKET = 'FAIRE_SUMMER_MARKET',
    ADD_USER = 'ADD_USER',
    NOTIFICATION_BELL = 'NOTIFICATION_BELL',
    NOTIFICATION_BELL_CHECKED = 'NOTIFICATION_BELL_CHECKED',
    /**
     * TODO: Update to align with Slate 2 (Arrow Up)
     */
    ARROW_TOP = 'ARROW_TOP',
    SETTINGS = 'SETTINGS',
    QUALITY = 'QUALITY',
    COMMUNICATION = 'COMMUNICATION',
    SPLIT = 'SPLIT',
    STOREFRONT = 'STOREFRONT',
    FILE_MULTIPLE = 'FILE_MULTIPLE',
    ARROW_DOWN = 'ARROW_DOWN',
    /**
     * External Icons
     */
    CLOVER = 'CLOVER',
    SHOPIFY_COLORED = 'SHOPIFY_COLORED',
    SHOPIFY_MONOTONE = 'SHOPIFY_MONOTONE',
    SQUARE = 'SQUARE',
    /**
     * Contextual Icons
     */
    INSIDER_KEY = 'INSIDER_KEY',
    TROPHY_ICON_SECONDARY = 'TROPHY_ICON_SECONDARY',
    VOLUME_BASED_DISCOUNT = 'VOLUME_BASED_DISCOUNT',
    GROW_WITH_FAIRE_TWINKLE = 'GROW_WITH_FAIRE_TWINKLE',
  }

  /**
   * Return an instance of IFaireIcon with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IFaireIcon>): IFaireIcon =>
    ({
      ...(partial ?? {}),
    }) as IFaireIcon;
}

export interface IFaireIcon {
  /**
   * Deprecated in favor of iconSize.
   * @deprecated
   */
  size: number | undefined;
  type: keyof typeof IFaireIcon.Type | undefined;
  /**
   * For new usages other than `CategoryPageEcoFriendlyProductsCarouselRecommender` use `colorToken` field instead.
   * @deprecated
   */
  color: string | undefined;
  /**
   * For new usage other than `CategoryPageEcoFriendlyProductsCarouselRecommender` use `backgroundColorToken` field.
   * @deprecated
   */
  background_color: string | undefined;
  /**
   * Color of the icon (stroke color).
   */
  color_token: keyof typeof ColorTokenKey | undefined;
  /**
   * Deprecated, background will be defined in parent element or component.
   * @deprecated
   */
  background_color_token: keyof typeof ColorTokenKey | undefined;
  /**
   * If the iconSize is set, the client will render the icon to be set size
   * If the iconSize is missing, the sizing from the closest container will be used(e.g. TextElement or Typography’s
   * font size). Otherwise, the client app’s default icon size will be used
   */
  icon_size: keyof typeof Sizing | undefined;
}
